import {NgModule} from '@angular/core'
import {AnimationStateDirective} from './animation-state/animation-state.directive'

@NgModule({declarations: [AnimationStateDirective], exports: [AnimationStateDirective]})
export class DirectivesModule {}
